// extracted by mini-css-extract-plugin
module.exports = {"container":"skills-module--container--1DROD","iconsContainer":"skills-module--iconsContainer--5TLQe","icons":"skills-module--icons--2pkny"};